import React from 'react';
import { connect } from 'react-redux';
import { preguntas } from '../properties';

import PasoUnoEliminarCuenta from './pasoUnoEliminarCuenta.cmpt.js';
import PasoDosEliminarCuenta from './pasoDosEliminarCuenta.cmpt.js';
import PasoTresEliminarCuenta from './pasoTresEliminarCuenta.cmpt.js';

const mapState = (state) => {
    return {
    	paso: state.miPerfil.pasoEliminar
    };
}

const mapDispatch = (dispatch) => {
    return {}
}

class ModalEliminarCuenta extends React.Component {
	state = {

	}
	
	render() {
		var Preguntas = preguntas,
            MakeItem = function(X) {
                return <option key={X.p} value={X.i}>{X.p}</option>;
            };
		return <div>
            { this.props.paso == 0 && 
                <PasoUnoEliminarCuenta />
            }
            { this.props.paso == 1 && 
                <PasoDosEliminarCuenta />
            }
            { this.props.paso == 2 && 
                <PasoTresEliminarCuenta />
            }
        </div>
	}
}

export default connect(mapState, mapDispatch)(ModalEliminarCuenta);


// WEBPACK FOOTER //
// ./src/miPerfil/modalEliminarCuenta.cmpt.js